jQuery(document).ready(function ($) {
    'use strict';

    var hash = window.location.hash.substring(1, window.location.hash.length);

    if (window.location.hash) {

        setTimeout(function () {

            if ( hash === 'presentation' ) {
                $('.showPresentation .toggle-lecture-overlay').trigger('click');
            }

        }, 300);

    }

    // Toggle Social Share
    $( document ).on( 'click', '.toggle-lecture-overlay', function(){

        if ($('body').hasClass('lecture-overlay-open')) {

            $('body').removeClass('lecture-overlay-open');
            $('#lecture-overlay').removeClass('visible');

        } else {

            $('body').addClass('lecture-overlay-open');
            $('#lecture-overlay').addClass('visible');

        }

    });
  
});